import { add, contains } from "@fluorescent/dom";
import bp from "@/lib/breakpoints";
const classes = {
  fullHeight: "section--full-height",
};

const mobileSizes = {
  default: 40,
  noPadding: 10,
};

const desktopSizes = {
  default: 80,
  noPadding: 10,
};

export default (node, options = { instant: false }) => {
  let threshold = 0;
  if (!options.instant) {
    // Get section size, this determines how much margin the section has
    let sectionSize = "default";
    if (contains(node, classes.fullHeight)) {
      sectionSize = "noPadding";
    }

    let margin = 80;
    if (bp.isLarge()) {
      margin = desktopSizes[sectionSize];
    } else {
      margin = mobileSizes[sectionSize];
    }
    threshold = Math.min(margin / node.offsetHeight, 0.5);
  }

  const observer = new IntersectionObserver(
    ([{ isIntersecting: visible }]) => {
      if (visible) {
        add(node, "is-visible");

        if (typeof options.cb === "function") {
          options.cb();
        }

        observer.disconnect();
      }
    },
    { threshold: threshold }
  );

  observer.observe(node);

  return {
    destroy() {
      observer?.disconnect();
    },
  };
};
